import FormGroup from "features/shared/forms/components/FormGroup";
import React from "react";
import Select from "react-select";
import reactSelectStyles from 'features/shared/components/reactSelect/reactselectcustom.module.scss';
import { Nullable } from "features/shared/types/nullable";
import OptionType from "features/shared/components/selectInput/OptionType";
import { Currency } from "features/shared/enums/currency";
import { useTranslation } from "react-i18next";

interface Props {
  name: string;
  currencies: Currency[];
  onChange: (currency: Nullable<Currency>) => void;
  visible: boolean;
  selectedCurrency?: Nullable<Currency>;
  errors?: Record<string, string>;
}

const CurrencySelect = ({ name, currencies, onChange, visible, selectedCurrency, errors }: Props) => {
  // translations
  const tLabels = useTranslation("requirements\\requirements").t;

  // helpers
  const convertToOptions = (currencies: Currency[]): OptionType[] => {
    return currencies.map((currency) => {return {name: currency, value: currency}})    
  }

  const getSelectedCurrency = (): Nullable<OptionType> /*| undefined*/ => {
    if (selectedCurrency) {
      return {
        name: selectedCurrency,
        value: selectedCurrency
      }
    } else {
      return null;
    }
  }

  // handlers
  const onChangeHandler = (currency: Nullable<OptionType>) => {
    onChange(currency ? currency.value as Currency : null);    
  }

  // render
  return (
    <FormGroup 
      labelText={tLabels("currencySelect.currency")}
      visible={visible}
      validationError={errors ? errors[name] : undefined}
    >
      <Select
        options={convertToOptions(currencies)}
        getOptionLabel={(currency) => currency.name}
        getOptionValue={(currency) => currency.value}
        value={getSelectedCurrency()}
        onChange={onChangeHandler}
        isSearchable={false}
        captureMenuScroll={false}
        className={reactSelectStyles.customSelect}
        classNamePrefix="customSelect"
        placeholder={tLabels("currencySelect.setCurrency")}
      />
    </FormGroup>
  )
}

export default CurrencySelect;
